<template>
    <svg
        width="660"
        height="509"
        viewBox="0 0 660 509"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <text
            x="287"
            y="58"
            font-family="Inter"
            font-weight="700"
            font-size="34"
            fill="var(--et-colors-text)"
        >
            FAQs
        </text>
        <text
            x="220"
            y="95"
            font-family="Inter"
            font-weight="500"
            font-size="15"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        >
            Can not find answer? Contact us
        </text>
        <path
            d="M373.367 99H451.128V99.8H373.367V99Z"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        />
        <g>
            <rect
                x="12"
                y="129"
                width="314"
                height="360"
                rx="12"
                fill="var(--et-colors-card-background)"
            />
            <text
                x="36"
                y="169"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                Will I receive a VAT invoice?
            </text>
            <rect
                x="36"
                y="183"
                width="266"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="36"
                y="199"
                width="184"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="36"
                y="215"
                width="114"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <text
                x="36"
                y="297"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                Can I return the purchased product?
            </text>
            <rect
                x="36"
                y="311"
                width="266"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="36"
                y="327"
                width="85"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <text
                x="36"
                y="409"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                How do I get the source file?
            </text>
            <rect
                x="36"
                y="423"
                width="266"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="36"
                y="439"
                width="179"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="36"
                y="455"
                width="199"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="334"
                y="129"
                width="314"
                height="360"
                rx="12"
                fill="var(--et-colors-card-background)"
            />
            <text
                x="358"
                y="169"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                Where I can get help?
            </text>
            <rect
                x="358"
                y="183"
                width="266"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="358"
                y="199"
                width="205"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <text
                x="358"
                y="281"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                Can I get a pro-forma invoice?
            </text>
            <rect
                x="358"
                y="295"
                width="266"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="358"
                y="311"
                width="205"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="358"
                y="327"
                width="190"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="358"
                y="343"
                width="222"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <text
                x="358"
                y="425"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                Can I share product with my family?
            </text>
            <rect
                x="358"
                y="439"
                width="266"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="358"
                y="455"
                width="94"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
        </g>
    </svg>
</template>
